module.exports = __webpack_public_path__ + "static/media/icon_27.d6deb6ee.svg";